import { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';
import { DEMO_WRITE_BLOCKED_EVENT, DEMO_WRITE_BLOCKED_MESSAGE } from '../../utils/demoMode';

export default function DemoWriteBlockedToast() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(DEMO_WRITE_BLOCKED_MESSAGE);

  useEffect(() => {
    const onBlocked = (event: Event) => {
      const detail = (event as CustomEvent<{ message?: string }>).detail;
      setMessage(detail?.message || DEMO_WRITE_BLOCKED_MESSAGE);
      setOpen(true);
    };
    window.addEventListener(DEMO_WRITE_BLOCKED_EVENT, onBlocked);
    return () => window.removeEventListener(DEMO_WRITE_BLOCKED_EVENT, onBlocked);
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={7000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={() => setOpen(false)} severity="warning" variant="filled" sx={{ width: '100%', maxWidth: 560 }}>
        {message}
      </Alert>
    </Snackbar>
  );
}
